import { BadgeColors } from '@triumph/design-system';
import {
  Carrier,
  CarrierBadge,
  CarrierNoaStatus,
} from '@/app/features/DebtorPortal/NOACenter/noaCenter.types';

/**
 * Resolve the single badge to display for a carrier.
 *
 * Document state takes precedence over relationship status for the two
 * document-derived badges (matches the prototype):
 *   - no document at all  -> "No NOA"
 *   - latest doc superseded -> "Superseded"
 * Otherwise the carrier's relationship status (Current/Expired/Pending) is used.
 */
export const resolveCarrierBadge = (carrier: Carrier): CarrierBadge => {
  if (!carrier.hasNoaDocument) return CarrierBadge.NoNoa;
  if (carrier.isSuperseded) return CarrierBadge.Superseded;

  switch (carrier.status) {
    case CarrierNoaStatus.Current:
      return CarrierBadge.Current;
    case CarrierNoaStatus.Expired:
      return CarrierBadge.Expired;
    case CarrierNoaStatus.Pending:
      return CarrierBadge.Pending;
    default:
      return CarrierBadge.NoNoa;
  }
};

/** Amber/gray aren't in BadgeColors, so document-state badges use custom hex. */
const AMBER = '#FBE7B2';
const GRAY = '#E3E9F2';

/** Map a display badge to a design-system Badge color (named or custom hex). */
export const badgeColor = (badge: CarrierBadge): BadgeColors | string => {
  switch (badge) {
    case CarrierBadge.Current:
      return BadgeColors.SUCCESS;
    case CarrierBadge.Expired:
      return BadgeColors.ERROR;
    case CarrierBadge.Pending:
      return AMBER;
    case CarrierBadge.NoNoa:
    case CarrierBadge.Superseded:
    default:
      return GRAY;
  }
};
